// extracted by mini-css-extract-plugin
module.exports = {"image":"ZenPreviewImage_image__oEvFv"};